import React from 'react';
import PropTypes from 'prop-types';
import { EditOutlined, CloseOutlined } from '@ant-design/icons';
import { Modal, Button, Radio } from 'antd';
import event from '~helpers/mixpanel';
import { IconCheck } from 'common/components/svgs';
import TutorialModal from '~components/pms-header/tutorial-modal';
import { setItem } from '~helpers/storage';
import { decodeBase64 } from 'common/helpers/decodeBase64';
import { pageType } from '~constants/pages';

export default class RejectModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rejectedReason: null,
      visible: false,
      tutorialVisible: false,
    };

    const { t } = props;

    this.allRejectReason = [
      t(
        'landlord.payment.long_tail.reject_booking.modal.move-in-and-move-out-data-not-available.option',
      ),
      t('landlord.payment.long_tail.reject_booking.modal.listing-not-available.option'),
      t('landlord.payment.long_tail.reject_booking.modal.lack-of-room.option'),
      t('landlord.payment.long_tail.reject_booking.modal.tenant-information-is-incomplete.option'),
    ];
  }

  componentDidMount() {
    if (this.props.isAutoOpen) {
      this.handleShowRejectModal();
    }
  }

  handleSelect = e => {
    this.setState({
      rejectedReason: e.target.value,
    });
  };

  handleShowRejectModal = () => {
    const { property, referenceId, bookingJourney, stage } = this.props.record || {};
    const { name, id, slug } = property || {};
    const decodedId = decodeBase64(id)?.id;
    const eventProperties = {
      'Clicked Position': 'Reject',
      'Property Name': name,
      'Property ID': decodedId,
      'Property Slug': slug,
      'Booking Stage': stage?.toLowerCase(),
      'Booking Journey': bookingJourney?.toLowerCase(),
      'Booking ID': referenceId,
    };

    if (this.props?.history?.location?.pathname === '/board') {
      eventProperties['Current Page Type'] = pageType.dashboard;
      event('Clicked Pending Information Btn', eventProperties);
    }
    if (this.props?.history?.location?.pathname?.includes('/detail')) {
      this.props?.handleClickActionBtnTrack?.('Reject');
    }
    if (this.props?.history?.location?.pathname === '/booking/list') {
      eventProperties['Current Page Type'] = pageType.bookingList;
      event('Clicked Action Btn in Booking List Page', eventProperties);
    }
    this.setState({
      rejectedReason: null,
      visible: !this.state.visible,
    });
  };

  handleToggleTutorial = () => {
    this.setState({
      tutorialVisible: !this.state.tutorialVisible,
    });
  };

  cancelModal = () => {
    this.setState({
      rejectedReason: null,
      visible: !this.state.visible,
    });
  };

  render() {
    const { id, type, t, rejectOrder, rejectLoading, record, openOrderCounterOfferModal } =
      this.props;
    const { rejectedReason, visible, tutorialVisible } = this.state;
    return (
      <div className="reject-modal">
        <Choose>
          <When condition={type === 'list'}>
            <button className="reject-modal__btn" onClick={this.handleShowRejectModal}>
              {t('landlord.long_tail.booking.action.reject')}
            </button>
          </When>
          <Otherwise>
            <Button onClick={this.handleShowRejectModal} className="reject-modal__btn--detail">
              <CloseOutlined />
              {t('landlord.long_tail.booking_details.btn.reject')}
            </Button>
          </Otherwise>
        </Choose>
        <Modal
          title={t('landlord.payment.long_tail.reject_booking.modal.title')}
          width={812}
          visible={visible}
          okText={t('confirm')}
          okType="danger"
          okButtonProps={{
            loading: rejectLoading,
            disabled: rejectLoading,
          }}
          onOk={() => {
            rejectOrder(id, t(rejectedReason), this.handleShowRejectModal);
          }}
          cancelText={t('landlord.payment.long_tail.button.cancel')}
          onCancel={this.cancelModal}
          wrapClassName="reject-modal__wrapper"
        >
          <div>
            <span className="reject-modal__reject-booking-desc">
              {t('landlord.payment.long_tail.reject_booking.modal.desc')}
            </span>
            <span className="reject-modal__reject-reason-title">
              {t('landlord.payment.long_tail.reject_booking.modal.reject_reason.title')}
            </span>

            <Radio.Group defaultValue={null} value={rejectedReason} onChange={this.handleSelect}>
              <For each="opt" index="idx" of={this.allRejectReason}>
                <Radio value={opt}>
                  <div className="reject-radio-option">{opt}</div>

                  <If condition={this.state.rejectedReason === opt && [0, 1].includes(idx)}>
                    <div className="reject-radio-notice">
                      <div className="reject-radio-notice--item">
                        <h4 className="reject-radio-notice--title">
                          {t(
                            'landlord.payment.long_tail.reject_booking.modal.notice.send_counter_offer.title',
                          )}
                        </h4>
                        <div className="reject-radio-notice--desc">
                          {t(
                            `landlord.payment.long_tail.reject_booking.modal.notice.send_counter_offer${
                              idx === 1 ? '.listing' : ''
                            }.desc`,
                          )}
                        </div>
                        <div className="reject-radio-notice--operations">
                          <div
                            className="reject-radio-notice--btn"
                            onClick={() => {
                              if (opt === this.allRejectReason[0]) {
                                setItem('counterOfferFrom', 'Reject Reason - Tenancy');
                              }
                              if (opt === this.allRejectReason[1]) {
                                setItem('counterOfferFrom', 'Reject Reason - Listing');
                              }

                              this.handleShowRejectModal();
                              openOrderCounterOfferModal(record);
                            }}
                          >
                            <EditOutlined />
                            <span className="reject-radio-notice--text">
                              {t('landlord.payment.long_tail.reject_booking.modal.button.send')}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="reject-radio-notice--item">
                        <h4 className="reject-radio-notice--title">
                          {t(
                            'landlord.payment.long_tail.reject_booking.modal.notice.what_is_counter_offer.title',
                          )}
                        </h4>
                        <div className="reject-radio-notice--desc">
                          {t(
                            'landlord.payment.long_tail.reject_booking.modal.notice.what_is_counter_offer.desc',
                          )}
                        </div>
                        <div className="reject-radio-notice--operations">
                          <div
                            className="reject-radio-notice--btn reject-radio-notice--check"
                            onClick={this.handleToggleTutorial}
                          >
                            <IconCheck />
                            <span className="reject-radio-notice--text">
                              {' '}
                              {t('landlord.payment.long_tail.reject_booking.modal.button.check')}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </If>
                </Radio>
              </For>
            </Radio.Group>
          </div>
        </Modal>

        <TutorialModal
          t={t}
          visible={tutorialVisible}
          onCancel={this.handleToggleTutorial}
          from={
            this.state.rejectedReason === this.allRejectReason[0]
              ? 'Reject Reason - Tenancy'
              : '"Reject Reason - Listing"'
          }
        />
      </div>
    );
  }
}

RejectModal.propTypes = {
  t: PropTypes.func,
  id: PropTypes.string,
  type: PropTypes.string,
  rejectOrder: PropTypes.func,
  isAutoOpen: PropTypes.bool,
  rejectLoading: PropTypes.bool,
  handleClickActionBtnTrack: PropTypes.func,
};

RejectModal.defaultProps = {
  t: () => {},
  id: '',
  type: '',
  rejectOrder: () => {},
  isAutoOpen: false,
  rejectLoading: false,
};
